import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const tooltipCss = ":host{display:inline-flex;line-height:0;position:relative;width:-webkit-fit-content;width:fit-content}.inner{display:inline-flex}.inner,.wrapper{height:100%;width:100%}";
const WuiTooltipStyle0 = tooltipCss;

const _groups = {};
const WuiTooltip = /*@__PURE__*/ proxyCustomElement(class WuiTooltip extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleClick = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'click') {
                return;
            }
            this.setOpen(!this.open);
            if (this.timeoutClose && this.timeoutClose > 0 && this.timeoutClose !== Number.POSITIVE_INFINITY) {
                this._timeoutClose = setTimeout(() => {
                    this.setOpen(false);
                }, this.timeoutClose);
            }
        };
        this.handleFocus = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.triggerOpen();
        };
        this.handleBlur = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.setOpen(false);
        };
        this.label = undefined;
        this.placement = 'top';
        this.trigger = 'focus';
        this.fixed = false;
        this.open = false;
        this.timeoutOpen = 200;
        this.timeoutClose = 1000;
        this.groupName = undefined;
        this.disabled = undefined;
    }
    onChangeOpen(newValue) {
        // Ignore this prop change when not under manual control
        if (this.trigger !== 'none') {
            return;
        }
        this.setOpen(!!newValue);
    }
    componentWillLoad() {
        if (this.trigger === 'none') {
            this.open = !!this.open;
        }
    }
    getGroup() {
        if (!this.groupName) {
            return;
        }
        if (!_groups[this.groupName]) {
            _groups[this.groupName] = {
                open: false,
                timeout: undefined,
            };
        }
        return _groups[this.groupName];
    }
    setOpen(open) {
        // Clear any existing timeouts that would have otherwise opened/closed the tooltip
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutClose && window.clearTimeout(this._timeoutClose);
        this.open = open;
        const group = this.getGroup();
        if (group) {
            // Clear timeout that otherwise would have marked the group as being closed
            group.timeout && clearTimeout(group.timeout);
            if (open) {
                // Set group to open
                group.open = true;
            }
            else {
                // Wait a little bit before marking the group as closed
                group.timeout = setTimeout(() => {
                    group.open = false;
                }, 1000);
            }
        }
    }
    triggerOpen() {
        // If part of a group that's already open
        const group = this.getGroup();
        // Clear an existing timeout
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutOpen = setTimeout(() => {
            this.setOpen(true);
        }, 
        // Skip timeout if group is already open
        group?.open ? 0 : this.timeoutOpen);
    }
    render() {
        return (h(Host, { key: '9ba1f98b9c643b3940826b9fa14225f03695d139', "aria-label": this.label }, h("div", { key: 'bf7bb25c3937eab82633f11f4336ca7ab468d4ec', class: "wrapper" }, h("wui-tooltip-label", { key: '1ecd9d2e42dc60fb717c19fb246e621235a076c1', open: this.open, label: this.label, placement: this.placement, fixed: this.fixed }), h("div", { key: '21a8afee378895fd195861d151163f2e9182d184', tabIndex: -1, onClick: this.handleClick, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.handleFocus, onMouseLeave: this.handleBlur, class: "inner" }, h("slot", { key: '13bd65c94fd93cb189efa88c81d682a8db0e350f' })))));
    }
    static get watchers() { return {
        "open": ["onChangeOpen"]
    }; }
    static get style() { return WuiTooltipStyle0; }
}, [1, "wui-tooltip", {
        "label": [1],
        "placement": [1],
        "trigger": [1],
        "fixed": [4],
        "open": [1540],
        "timeoutOpen": [2, "timeout-open"],
        "timeoutClose": [2, "timeout-close"],
        "groupName": [1, "group-name"],
        "disabled": [516]
    }, undefined, {
        "open": ["onChangeOpen"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTooltip);
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTooltip as W, defineCustomElement as d };

//# sourceMappingURL=tooltip.js.map